import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/itaobuy-spreadsheet-guide", element: <ArticlePage /> },
  { path: "/why-itabuy-spreadsheet", element: <ArticlePage /> },
  { path: "/itaobuy-vs-traditional", element: <ArticlePage /> },
  { path: "/save-time-itaobuy", element: <ArticlePage /> },
  { path: "/itaobuy-safety", element: <ArticlePage /> },
  { path: "/itaobuy-beginner", element: <ArticlePage /> },
  { path: "/itaobuy-category-guide", element: <ArticlePage /> },
  { path: "/itaobuy-price-tracking", element: <ArticlePage /> },
  { path: "/itaobuy-mobile", element: <ArticlePage /> },
  { path: "/itaobuy-bulk", element: <ArticlePage /> },
  { path: "/itaobuy-seasonal", element: <ArticlePage /> },
  { path: "/itaobuy-tools", element: <ArticlePage /> },
  { path: "/itaobuy-success", element: <ArticlePage /> },
  { path: "/itaobuy-faq", element: <ArticlePage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;